import React from "react";
import "../css/AcGasRefil.css";
import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer"; 
import Herolast  from "../screen/herolast";

export default function AcGasRefill() {
  return (
    <>
    <Topbar/>
      <Header />
      {/* Hero (your original card) */}
      <section className="ac-hero">
        <div className="ac-hero-bg" />

        <div className="ac-hero-card">
          <p className="ac-hero-kicker">Cool Comfort</p>

          <h1 className="ac-hero-title">
           Professional AC Gas Refill
            <br />
           Service for Optimal
           <br/>
           Performance
          </h1>

          <p className="ac-hero-subtitle">
            Get all kinds of AC service at your doorstep in 30 minutes. Schedule
            your service now!
          </p>

          <a className="ac-hero-cta" href="tel:7237898275">
            7237898275
          </a>
        </div>
      </section>

        {/* === New content section: two-column layout like screenshots === */}
      <section className="ac-article-section">
        <div className="container ac-article-grid">
          <div className="ac-article-text">
            <h2 className="ac-article-heading">Your Trusted Partner for All AC Gas Refill Needs</h2>

            <p>Your Trusted Partner for All AC Gas Refill Needs
When it comes to maintaining a comfortable indoor environment, ensuring your air conditioning system operates efficiently is essential. At <a className="ac-link" href="#">Jay Ambe AC Service</a>  we specialize in providing comprehensive <strong>AC gas refill services</strong> tailored to meet the needs of both residential and commercial clients. With years of experience in the industry, our skilled technicians are dedicated to delivering reliable solutions that enhance your cooling system’s performance.
            </p>

            <p>
            Over time, air conditioners can lose refrigerant due to leaks or regular usage. This depletion not only affects the cooling efficiency but can also lead to increased energy bills and potential damage to your unit. Our expert team at Jay Ambe AC Service understands the importance of timely gas refills and conducts thorough inspections to identify any issues before they escalate.
            </p>

            <p>
            We offer a wide range of refrigerants suitable for various AC models, ensuring that we provide the right solution for your specific system. Our service includes a complete check-up of your air conditioning unit, identification of any leaks or faults, and professional gas refilling using high-quality refrigerants that comply with safety standards.            </p>

            <p>
       Customer satisfaction is our top priority; therefore, we strive to provide prompt and affordable services without compromising quality. Whether you need a one-time refill or regular maintenance checks, Jay Ambe AC Service is here to help. We take pride in our transparent pricing model—no hidden fees or surprises!
            </p>

            <p>
          Additionally, we believe in transparent communication with our clients throughout the entire process. You will always know what steps we’re taking and why they matter for both safety and functionality.
            </p>

            <p>
                Choose Jay Ambe AC Service for all your AC gas refill needs and experience unparalleled professionalism and expertise. Contact us today for an appointment, and let us ensure you stay cool during those hot months!
            </p>

          </div>

          <div className="ac-article-image-wrap">
            <img
              className="ac-article-image"
              src={require("../assets/AcGas.jpg")}
              alt="AC service"
            />
          </div>
        </div>
      </section>
      <Herolast  />
      <Footer  />
     
    </>
  );
}
